import icCamera from '../../images/ic_camera.png';
import icChat from '../../images/ic_chat.png';
import icChatBlue from '../../images/ic_chat_blue.png';
import icCheckBoxOff from '../../images/ic_checkbox_off.png';
import icCheckBoxOn from '../../images/ic_checkbox_on.png';
import icClose from '../../images/ic_close.png';
import icCloseBlack from '../../images/ic_close_black.png';
import icDelete from '../../images/ic_delete.png';
import icDownArrow from '../../images/ic_down_arrow.png';
import icDownArrowBlack from '../../images/ic_down_arrow_black.png';
import icDownArrowCircle from '../../images/ic_down_arrow_circle.png';
import icDropDown from '../../images/ic_dropdown.png';
import icFillter from '../../images/ic_fillter.png';
import icGallery from '../../images/ic_gallery.png';
import icHome from '../../images/ic_home.png';
import icImageInfoInvisible from '../../images/ic_imageinfo_invisible.png';
import icImageInfoVisible from '../../images/ic_imageinfo_visible.png';
import icInfo from '../../images/ic_info.png';
import icInfoBlack from '../../images/ic_info_black.png';
import icLeftArrow from '../../images/ic_left_arrow.png';
import icLeftArrowBlack from '../../images/ic_left_arrow_black.png';
import icPencil from '../../images/ic_pencil.png';
import icPencilBlack from '../../images/ic_pencil_black.png';
import icPicture from '../../images/ic_picture.png';
import icPlus from '../../images/ic_plus.png';
import icReport from '../../images/ic_report.png';
import icRightArrow from '../../images/ic_right_arrow.png';
import icRightArrowBlack from '../../images/ic_right_arrow_black.png';
import icSelected from '../../images/ic_selected.png';
import icSend from '../../images/ic_send.png';
import icUpArrow from '../../images/ic_up_arrow.png';
import icUpArrowBlack from '../../images/ic_up_arrow_black.png';
import icUser from '../../images/ic_user.png';
import icGroup from '../../images/ic_group.png';
import icFriend from '../../images/ic_friend.png';
import icSetting from '../../images/ic_setting.png';
import icBook from '../../images/ic_book.png';
import icRobot from '../../images/ic_robot.png';
import icSearch from '../../images/ic_search.png';
import icCheckOn from '../../images/ic_check_on.png';



/** ================================
*  共通アイコン
*  ================================*/
export default class IconImages {
  static readonly icCamera = icCamera;
  static readonly icChat = icChat;
  static readonly icChatBlue = icChatBlue;
  static readonly icCheckBoxOff = icCheckBoxOff;
  static readonly icCheckBoxOn = icCheckBoxOn;
  static readonly icClose = icClose;
  static readonly icCloseBlack = icCloseBlack;
  static readonly icDelete = icDelete;
  static readonly icDownArrow = icDownArrow;
  static readonly icDownArrowBlack = icDownArrowBlack;
  static readonly icDownArrowCircle = icDownArrowCircle;
  static readonly icDropDown = icDropDown;
  static readonly icFillter = icFillter;
  static readonly icGallery = icGallery;
  static readonly icHome = icHome;
  static readonly icImageInfoInvisible = icImageInfoInvisible;
  static readonly icImageInfoVisible = icImageInfoVisible;
  static readonly icInfo = icInfo;
  static readonly icInfoBlack = icInfoBlack;
  static readonly icLeftArrow = icLeftArrow;
  static readonly icLeftArrowBlack = icLeftArrowBlack;
  static readonly icPencil = icPencil;
  static readonly icPencilBlack = icPencilBlack;
  static readonly icPicture = icPicture;
  static readonly icPlus = icPlus;
  static readonly icReport = icReport;
  static readonly icRightArrow = icRightArrow;
  static readonly icRightArrowBlack = icRightArrowBlack;
  static readonly icSelected = icSelected;
  static readonly icSend = icSend;
  static readonly icUpArrow = icUpArrow;
  static readonly icUpArrowBlack = icUpArrowBlack;
  static readonly icSearch = icSearch;
  static readonly icCheckOn = icCheckOn;

  // タブアイコン
  static readonly icFriend = icFriend;
  static readonly icSetting = icSetting;
  static readonly icBook = icBook;
  static readonly icRobot = icRobot;

  // ユーザーアイコン
  static readonly icUser = icUser;
  static readonly icGroup = icGroup;
}
